module.exports = __webpack_public_path__ + "static/media/rainbow.37698a15.jpg";